import React from 'react';

import {Link} from 'react-router';

import {UserAvatar} from 'app/components/general/avatars';
import {getUserDetailPageURL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {DateText, FixableHeader, FixableTable} from './utils';

import {DocTaskReportItemType, ReportResultSerializedType} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<DocTaskReportItemType>;
}

export function RenderTeammateRecognitionSummary({result}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Email')}</FixableHeader>
          <FixableHeader>{gt('Teams')}</FixableHeader>
          <FixableHeader textAlign="center">
            {gt('Documents viewed')}
          </FixableHeader>
          <FixableHeader textAlign="center">
            {gt('Drafts edited')}
          </FixableHeader>
          <FixableHeader textAlign="center">
            {gt('Steps checked off')}
          </FixableHeader>
          <FixableHeader>{gt('Last Seen At')}</FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <div className="d-flex align-items-center">
                <UserAvatar user={r['user']} small showCard className="mr-2" />
                <Link
                  to={getUserDetailPageURL(r['user']['id'])}
                  className="font-weight-bold"
                >
                  {r['user']['name']}
                </Link>
              </div>
            </td>
            <td>
              <div className="d-flex align-items-center">
                {r['user']['email']}
              </div>
            </td>
            <td>
              <ul className="mb-0 pl-4">
                {r.teams.map((t) => (
                  <li key={t.html_url}>
                    <Link to={t.html_url}>{t.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td className="text-right pr-5">{r['num_documents_viewed']}</td>
            <td className="text-right pr-5">{r['num_drafts_edited']}</td>
            <td className="text-right pr-5">{r['num_steps_checked_off']}</td>
            <td>
              {r['last_seen_at'] != null ? (
                <DateText>{r['last_seen_at']}</DateText>
              ) : (
                gt('Never Logged In')
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
